// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --unified-primary-green: #D4EAA5;
  --unified-primary-green-light: #E2F2C1;
  --unified-primary-green-dark: #C4DA8F;
  --unified-primary-green-darker: #B4CA7F;
  --unified-primary-blue: #A5C8EA;
  --unified-primary-blue-light: #C1DCF2;
  --unified-primary-blue-dark: #8FB8DA;
  --unified-primary-blue-darker: #7FA8CA;
  --unified-header-bg: #E3F2FD;
  --unified-header-bg-dark: #1A237E;
  --unified-content-bg: #F8FBFF;
  --unified-content-bg-dark: #121212;
  --unified-white: #FFFFFF;
  --unified-gray-50: #FAFAFA;
  --unified-gray-100: #F5F5F5;
  --unified-gray-200: #EEEEEE;
  --unified-gray-300: #E0E0E0;
  --unified-gray-400: #BDBDBD;
  --unified-gray-500: #9E9E9E;
  --unified-gray-600: #757575;
  --unified-gray-700: #616161;
  --unified-gray-800: #424242;
  --unified-gray-900: #212121;
  --unified-success: #D4EAA5;
  --unified-success-light: #E2F2C1;
  --unified-success-dark: #B4CA7F;
  --unified-info: #A5C8EA;
  --unified-info-light: #C1DCF2;
  --unified-info-dark: #7FA8CA;
  --unified-warning: #F5D982;
  --unified-warning-light: #F8E5A8;
  --unified-warning-dark: #F0D066;
  --unified-danger: #F5A5A5;
  --unified-danger-light: #F8C1C1;
  --unified-danger-dark: #F08F8F;
  --unified-text-primary: #212121;
  --unified-text-secondary: #666666;
  --unified-text-disabled: #9E9E9E;
  --unified-text-on-primary: #FFFFFF;
  --unified-border-light: #E1E8ED;
  --unified-border-medium: #BDBDBD;
  --unified-border-dark: #757575;
  --unified-shadow-light: rgba(0, 0, 0, 0.08);
  --unified-shadow-medium: rgba(0, 0, 0, 0.12);
  --unified-shadow-dark: rgba(0, 0, 0, 0.16);
}

[data-theme=dark] {
  --unified-header-bg: var(--unified-header-bg-dark);
  --unified-content-bg: var(--unified-content-bg-dark);
  --unified-text-primary: #E0E0E0;
  --unified-text-secondary: #BDBDBD;
  --unified-text-disabled: #757575;
  --unified-border-light: rgba(255, 255, 255, 0.12);
  --unified-border-medium: rgba(255, 255, 255, 0.24);
  --unified-border-dark: rgba(255, 255, 255, 0.38);
  --unified-shadow-light: rgba(0, 0, 0, 0.24);
  --unified-shadow-medium: rgba(0, 0, 0, 0.32);
  --unified-shadow-dark: rgba(0, 0, 0, 0.48);
}

:root {
  --unified-gradient-green: linear-gradient(135deg, var(--unified-primary-green) 0%, var(--unified-primary-green-dark) 100%);
  --unified-gradient-blue: linear-gradient(135deg, var(--unified-primary-blue) 0%, var(--unified-primary-blue-dark) 100%);
  --unified-gradient-kpi-1: linear-gradient(135deg, #A5C8EA 0%, #7FA8CA 100%);
  --unified-gradient-kpi-2: linear-gradient(135deg, #D4EAA5 0%, #B4CA7F 100%);
  --unified-gradient-kpi-3: linear-gradient(135deg, #F5D982 0%, #F0D066 100%);
  --unified-gradient-kpi-4: linear-gradient(135deg, #F5A5A5 0%, #F08F8F 100%);
  --unified-gradient-sea: linear-gradient(135deg, #A5C8EA 0%, #7FA8CA 100%);
  --unified-gradient-air: linear-gradient(135deg, #C8A5EA 0%, #B87FCA 100%);
  --unified-gradient-road: linear-gradient(135deg, #F5A5A5 0%, #F08F8F 100%);
  --unified-gradient-rail: linear-gradient(135deg, #F5D982 0%, #F0D066 100%);
  --unified-gradient-unknown: linear-gradient(135deg, var(--unified-gray-500) 0%, var(--unified-gray-600) 100%);
  --unified-gradient-import: linear-gradient(135deg, #D4EAA5 0%, #B4CA7F 100%);
  --unified-gradient-export: linear-gradient(135deg, #A5C8EA 0%, #7FA8CA 100%);
  --unified-gradient-transit: linear-gradient(135deg, #F5D982 0%, #F0D066 100%);
  --unified-gradient-other: linear-gradient(135deg, #C8A5EA 0%, #B87FCA 100%);
}

.unified-bg-primary {
  background-color: var(--unified-primary-green) !important;
}

.unified-bg-primary-light {
  background-color: var(--unified-primary-green-light) !important;
}

.unified-bg-primary-dark {
  background-color: var(--unified-primary-green-dark) !important;
}

.unified-bg-secondary {
  background-color: var(--unified-primary-blue) !important;
}

.unified-bg-secondary-light {
  background-color: var(--unified-primary-blue-light) !important;
}

.unified-bg-secondary-dark {
  background-color: var(--unified-primary-blue-dark) !important;
}

.unified-bg-success {
  background-color: var(--unified-success) !important;
}

.unified-bg-info {
  background-color: var(--unified-info) !important;
}

.unified-bg-warning {
  background-color: var(--unified-warning) !important;
}

.unified-bg-danger {
  background-color: var(--unified-danger) !important;
}

.unified-text-primary {
  color: var(--unified-text-primary) !important;
}

.unified-text-secondary {
  color: var(--unified-text-secondary) !important;
}

.unified-text-success {
  color: var(--unified-success-dark) !important;
}

.unified-text-info {
  color: var(--unified-info-dark) !important;
}

.unified-text-warning {
  color: var(--unified-warning-dark) !important;
}

.unified-text-danger {
  color: var(--unified-danger-dark) !important;
}

.unified-border-light {
  border-color: var(--unified-border-light) !important;
}

.unified-border-medium {
  border-color: var(--unified-border-medium) !important;
}

.unified-border-dark {
  border-color: var(--unified-border-dark) !important;
}

.unified-button-primary {
  --background: var(--unified-primary-green);
  --background-hover: var(--unified-primary-green-dark);
  --color: var(--unified-text-on-primary);
  --border-color: var(--unified-primary-green-dark);
}

.unified-button-secondary {
  --background: var(--unified-primary-blue);
  --background-hover: var(--unified-primary-blue-dark);
  --color: var(--unified-text-on-primary);
  --border-color: var(--unified-primary-blue-dark);
}

.unified-button-success {
  --background: var(--unified-success);
  --background-hover: var(--unified-success-dark);
  --color: var(--unified-text-on-primary);
  --border-color: var(--unified-success-dark);
}

.unified-button-outline-primary {
  --background: transparent;
  --background-hover: var(--unified-primary-green-light);
  --color: var(--unified-primary-green-dark);
  --border-color: var(--unified-primary-green);
}

.unified-card-primary {
  background: var(--unified-gradient-green);
  color: var(--unified-text-on-primary);
  border: 1px solid var(--unified-primary-green-dark);
}

.unified-card-secondary {
  background: var(--unified-gradient-blue);
  color: var(--unified-text-on-primary);
  border: 1px solid var(--unified-primary-blue-dark);
}

body.dark {
  --unified-primary-green: #D4EAA5;
  --unified-primary-green-light: #E2F2C1;
  --unified-primary-green-dark: #B4CA7F;
  --unified-primary-green-darker: #A4BA6F;
  --unified-primary-blue: #90CAF9;
  --unified-primary-blue-light: #BBDEFB;
  --unified-primary-blue-dark: #64B5F6;
  --unified-primary-blue-darker: #42A5F5;
  --unified-header-bg: #1A237E;
  --unified-header-bg-dark: #0D47A1;
  --unified-content-bg: #121212;
  --unified-content-bg-dark: #000000;
  --unified-white: #1E1E1E;
  --unified-gray-50: #2A2A2A;
  --unified-gray-100: #333333;
  --unified-gray-200: #404040;
  --unified-gray-300: #4D4D4D;
  --unified-gray-400: #666666;
  --unified-gray-500: #808080;
  --unified-gray-600: #999999;
  --unified-gray-700: #404040;
  --unified-gray-800: #2A2A2A;
  --unified-gray-900: #1E1E1E;
  --unified-success: #D4EAA5;
  --unified-success-light: #E2F2C1;
  --unified-success-dark: #B4CA7F;
  --unified-info: #90CAF9;
  --unified-info-light: #BBDEFB;
  --unified-info-dark: #64B5F6;
  --unified-warning: #FFD54F;
  --unified-warning-light: #FFECB3;
  --unified-warning-dark: #FFC107;
  --unified-danger: #EF5350;
  --unified-danger-light: #FFCDD2;
  --unified-danger-dark: #D32F2F;
  --unified-text-primary: #FFFFFF;
  --unified-text-secondary: #E0E0E0;
  --unified-text-tertiary: #BDBDBD;
  --unified-text-disabled: #757575;
  --unified-text-on-primary: #000000;
  --unified-text-on-secondary: #000000;
  --unified-border-light: rgba(255, 255, 255, 0.12);
  --unified-border-medium: rgba(255, 255, 255, 0.24);
  --unified-border-dark: rgba(255, 255, 255, 0.38);
  --unified-shadow-light: rgba(0, 0, 0, 0.48);
  --unified-shadow-medium: rgba(0, 0, 0, 0.64);
  --unified-shadow-dark: rgba(0, 0, 0, 0.80);
}

.unified-card-light {
  background: var(--unified-white);
  color: var(--unified-text-primary);
  border: 1px solid var(--unified-border-light);
  box-shadow: 0 2px 4px var(--unified-shadow-light);
}

.unified-status-active {
  background: var(--unified-success);
  color: var(--unified-text-on-primary);
}

.unified-status-pending {
  background: var(--unified-warning);
  color: var(--unified-text-primary);
}

.unified-status-inactive {
  background: var(--unified-gray-400);
  color: var(--unified-text-on-primary);
}

.unified-status-error {
  background: var(--unified-danger);
  color: var(--unified-text-on-primary);
}

.unified-transition {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.unified-hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px var(--unified-shadow-medium);
}

.unified-hover-glow:hover {
  box-shadow: 0 0 0 3px rgba(212, 234, 165, 0.3);
}

@media (max-width: 768px) {
  :root {
    --unified-shadow-light: rgba(0, 0, 0, 0.06);
    --unified-shadow-medium: rgba(0, 0, 0, 0.10);
  }
}
@media print {
  :root {
    --unified-text-primary: #000000;
    --unified-text-secondary: #333333;
    --unified-border-light: #CCCCCC;
  }
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.loading-overlay.overlay-mode {
  background: rgba(var(--unified-white), 0.9);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  border-radius: inherit;
}
.loading-overlay .loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.loading-overlay .loading-content .spinner-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-overlay .loading-content .spinner-container .spinner-ring {
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
  animation: spin 2s linear infinite;
}
.loading-overlay .loading-content .spinner-container .spinner-ring.ring-1 {
  width: 40px;
  height: 40px;
  border-top-color: var(--unified-primary-blue);
  animation-delay: 0s;
}
.loading-overlay .loading-content .spinner-container .spinner-ring.ring-2 {
  width: 32px;
  height: 32px;
  border-top-color: var(--unified-primary-green);
  animation-delay: -0.3s;
  animation-duration: 1.5s;
}
.loading-overlay .loading-content .spinner-container .spinner-ring.ring-3 {
  width: 24px;
  height: 24px;
  border-top-color: var(--unified-info);
  animation-delay: -0.6s;
  animation-duration: 1s;
}
.loading-overlay .loading-content .loading-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--unified-text-secondary);
  text-align: center;
  animation: fadeInUp 0.6s ease-out;
}
.loading-overlay[data-size=small] .loading-content {
  gap: 12px;
}
.loading-overlay[data-size=small] .loading-content .spinner-container .spinner-ring.ring-1 {
  width: 28px;
  height: 28px;
}
.loading-overlay[data-size=small] .loading-content .spinner-container .spinner-ring.ring-2 {
  width: 22px;
  height: 22px;
}
.loading-overlay[data-size=small] .loading-content .spinner-container .spinner-ring.ring-3 {
  width: 16px;
  height: 16px;
}
.loading-overlay[data-size=small] .loading-content .loading-text {
  font-size: 12px;
}
.loading-overlay[data-size=large] .loading-content {
  gap: 20px;
}
.loading-overlay[data-size=large] .loading-content .spinner-container .spinner-ring.ring-1 {
  width: 56px;
  height: 56px;
}
.loading-overlay[data-size=large] .loading-content .spinner-container .spinner-ring.ring-2 {
  width: 44px;
  height: 44px;
}
.loading-overlay[data-size=large] .loading-content .spinner-container .spinner-ring.ring-3 {
  width: 32px;
  height: 32px;
}
.loading-overlay[data-size=large] .loading-content .loading-text {
  font-size: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/styles/unified-color-palette.scss","webpack://./src/app/shared/components/loading-overlay/loading-overlay.component.scss"],"names":[],"mappings":"AAIA;EAEE,gCAAA;EACA,sCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,+BAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,4BAAA;EACA,iCAAA;EACA,6BAAA;EACA,kCAAA;EAGA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EAGA,0BAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,6BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,gCAAA;EACA,+BAAA;EAEA,yBAAA;EACA,+BAAA;EACA,8BAAA;EAGA,+BAAA;EACA,iCAAA;EACA,gCAAA;EACA,kCAAA;EAGA,+BAAA;EACA,gCAAA;EACA,8BAAA;EAGA,2CAAA;EACA,4CAAA;EACA,0CAAA;ACrBF;;ADyBA;EACE,kDAAA;EACA,oDAAA;EAEA,+BAAA;EACA,iCAAA;EACA,gCAAA;EAEA,iDAAA;EACA,kDAAA;EACA,gDAAA;EAEA,2CAAA;EACA,4CAAA;EACA,0CAAA;ACzBF;;AD6BA;EAEE,0HAAA;EACA,uHAAA;EAGA,2EAAA;EACA,2EAAA;EACA,2EAAA;EACA,2EAAA;EAGA,yEAAA;EACA,yEAAA;EACA,0EAAA;EACA,0EAAA;EACA,6GAAA;EAGA,4EAAA;EACA,4EAAA;EACA,6EAAA;EACA,2EAAA;ACjCF;;ADqCA;EAAsB,yDAAA;ACjCtB;;ADkCA;EAA4B,+DAAA;AC9B5B;;AD+BA;EAA2B,8DAAA;AC3B3B;;AD6BA;EAAwB,wDAAA;ACzBxB;;AD0BA;EAA8B,8DAAA;ACtB9B;;ADuBA;EAA6B,6DAAA;ACnB7B;;ADqBA;EAAsB,mDAAA;ACjBtB;;ADkBA;EAAmB,gDAAA;ACdnB;;ADeA;EAAsB,mDAAA;ACXtB;;ADYA;EAAqB,kDAAA;ACRrB;;ADUA;EAAwB,6CAAA;ACNxB;;ADOA;EAA0B,+CAAA;ACH1B;;ADIA;EAAwB,6CAAA;ACAxB;;ADCA;EAAqB,0CAAA;ACGrB;;ADFA;EAAwB,6CAAA;ACMxB;;ADLA;EAAuB,4CAAA;ACSvB;;ADPA;EAAwB,oDAAA;ACWxB;;ADVA;EAAyB,qDAAA;ACczB;;ADbA;EAAuB,mDAAA;ACiBvB;;ADdA;EACE,0CAAA;EACA,qDAAA;EACA,uCAAA;EACA,iDAAA;ACiBF;;ADdA;EACE,yCAAA;EACA,oDAAA;EACA,uCAAA;EACA,gDAAA;ACiBF;;ADdA;EACE,oCAAA;EACA,+CAAA;EACA,uCAAA;EACA,2CAAA;ACiBF;;ADdA;EACE,yBAAA;EACA,sDAAA;EACA,0CAAA;EACA,4CAAA;ACiBF;;ADbA;EACE,yCAAA;EACA,qCAAA;EACA,mDAAA;ACgBF;;ADbA;EACE,wCAAA;EACA,qCAAA;EACA,kDAAA;ACgBF;;ADZA;EAEE,gCAAA;EACA,sCAAA;EACA,qCAAA;EACA,uCAAA;EAEA,+BAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,4BAAA;EACA,iCAAA;EACA,6BAAA;EACA,kCAAA;EAGA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EAGA,0BAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,6BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,gCAAA;EACA,+BAAA;EAEA,yBAAA;EACA,+BAAA;EACA,8BAAA;EAGA,+BAAA;EACA,iCAAA;EACA,gCAAA;EACA,gCAAA;EACA,kCAAA;EACA,oCAAA;EAGA,iDAAA;EACA,kDAAA;EACA,gDAAA;EAGA,2CAAA;EACA,4CAAA;EACA,0CAAA;ACFF;;ADKA;EACE,gCAAA;EACA,kCAAA;EACA,6CAAA;EACA,iDAAA;ACFF;;ADMA;EACE,kCAAA;EACA,qCAAA;ACHF;;ADMA;EACE,kCAAA;EACA,kCAAA;ACHF;;ADMA;EACE,mCAAA;EACA,qCAAA;ACHF;;ADMA;EACE,iCAAA;EACA,qCAAA;ACHF;;ADOA;EACE,iDAAA;ACJF;;ADOA;EACE,2BAAA;EACA,kDAAA;ACJF;;ADOA;EACE,8CAAA;ACJF;;ADQA;EACE;IAEE,2CAAA;IACA,4CAAA;ECNF;AACF;ADUA;EACE;IAEE,+BAAA;IACA,iCAAA;IACA,+BAAA;ECTF;AACF;AAvSA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAySF;AAvSE;EACE,2CAAA;EACA,kCAAA;UAAA,0BAAA;EACA,sBAAA;AAySJ;AAtSE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAwSJ;AAtSI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAwSN;AAtSM;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kCAAA;AAwSR;AAtSQ;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EACA,mBAAA;AAwSV;AArSQ;EACE,WAAA;EACA,YAAA;EACA,8CAAA;EACA,sBAAA;EACA,wBAAA;AAuSV;AApSQ;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;EACA,sBAAA;AAsSV;AAjSI;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iCAAA;AAmSN;AA7RI;EACE,SAAA;AA+RN;AA5RQ;EAAW,WAAA;EAAa,YAAA;AAgShC;AA/RQ;EAAW,WAAA;EAAa,YAAA;AAmShC;AAlSQ;EAAW,WAAA;EAAa,YAAA;AAsShC;AAnSM;EACE,eAAA;AAqSR;AA/RI;EACE,SAAA;AAiSN;AA9RQ;EAAW,WAAA;EAAa,YAAA;AAkShC;AAjSQ;EAAW,WAAA;EAAa,YAAA;AAqShC;AApSQ;EAAW,WAAA;EAAa,YAAA;AAwShC;AArSM;EACE,eAAA;AAuSR;;AAhSA;EACE;IAAK,uBAAA;EAoSL;EAnSA;IAAO,yBAAA;EAsSP;AACF;AApSA;EACE;IACE,UAAA;IACA,2BAAA;EAsSF;EApSA;IACE,UAAA;IACA,wBAAA;EAsSF;AACF","sourcesContent":["// Unified Color Palette - Customer Detail Components\n// Base color: Green #D4EAA5 as specified by user\n\n// Primary Color Palette\n:root {\n  // Main Brand Colors\n  --unified-primary-green: #D4EAA5;\n  --unified-primary-green-light: #E2F2C1;\n  --unified-primary-green-dark: #C4DA8F;\n  --unified-primary-green-darker: #B4CA7F;\n  \n  // Complementary Blue (for headers and accents)\n  --unified-primary-blue: #A5C8EA;\n  --unified-primary-blue-light: #C1DCF2;\n  --unified-primary-blue-dark: #8FB8DA;\n  --unified-primary-blue-darker: #7FA8CA;\n  \n  // Header Background (light blue from reference)\n  --unified-header-bg: #E3F2FD;\n  --unified-header-bg-dark: #1A237E;\n  --unified-content-bg: #F8FBFF;\n  --unified-content-bg-dark: #121212;\n  \n  // Neutral Colors\n  --unified-white: #FFFFFF;\n  --unified-gray-50: #FAFAFA;\n  --unified-gray-100: #F5F5F5;\n  --unified-gray-200: #EEEEEE;\n  --unified-gray-300: #E0E0E0;\n  --unified-gray-400: #BDBDBD;\n  --unified-gray-500: #9E9E9E;\n  --unified-gray-600: #757575;\n  --unified-gray-700: #616161;\n  --unified-gray-800: #424242;\n  --unified-gray-900: #212121;\n  \n  // Semantic Colors (coordinated with main palette)\n  --unified-success: #D4EAA5; // Use main green for success\n  --unified-success-light: #E2F2C1;\n  --unified-success-dark: #B4CA7F;\n  \n  --unified-info: #A5C8EA; // Use main blue for info\n  --unified-info-light: #C1DCF2;\n  --unified-info-dark: #7FA8CA;\n  \n  --unified-warning: #F5D982; // Coordinated yellow\n  --unified-warning-light: #F8E5A8;\n  --unified-warning-dark: #F0D066;\n  \n  --unified-danger: #F5A5A5; // Coordinated red\n  --unified-danger-light: #F8C1C1;\n  --unified-danger-dark: #F08F8F;\n  \n  // Text Colors\n  --unified-text-primary: #212121;\n  --unified-text-secondary: #666666;\n  --unified-text-disabled: #9E9E9E;\n  --unified-text-on-primary: #FFFFFF;\n  \n  // Border Colors\n  --unified-border-light: #E1E8ED;\n  --unified-border-medium: #BDBDBD;\n  --unified-border-dark: #757575;\n  \n  // Shadow Colors\n  --unified-shadow-light: rgba(0, 0, 0, 0.08);\n  --unified-shadow-medium: rgba(0, 0, 0, 0.12);\n  --unified-shadow-dark: rgba(0, 0, 0, 0.16);\n}\n\n// Dark Theme Overrides\n[data-theme=\"dark\"] {\n  --unified-header-bg: var(--unified-header-bg-dark);\n  --unified-content-bg: var(--unified-content-bg-dark);\n  \n  --unified-text-primary: #E0E0E0;\n  --unified-text-secondary: #BDBDBD;\n  --unified-text-disabled: #757575;\n  \n  --unified-border-light: rgba(255, 255, 255, 0.12);\n  --unified-border-medium: rgba(255, 255, 255, 0.24);\n  --unified-border-dark: rgba(255, 255, 255, 0.38);\n  \n  --unified-shadow-light: rgba(0, 0, 0, 0.24);\n  --unified-shadow-medium: rgba(0, 0, 0, 0.32);\n  --unified-shadow-dark: rgba(0, 0, 0, 0.48);\n}\n\n// Gradient Definitions (coordinated with main palette)\n:root {\n  // Primary Gradients\n  --unified-gradient-green: linear-gradient(135deg, var(--unified-primary-green) 0%, var(--unified-primary-green-dark) 100%);\n  --unified-gradient-blue: linear-gradient(135deg, var(--unified-primary-blue) 0%, var(--unified-primary-blue-dark) 100%);\n  \n  // KPI Card Gradients (coordinated)\n  --unified-gradient-kpi-1: linear-gradient(135deg, #A5C8EA 0%, #7FA8CA 100%); // Blue variant\n  --unified-gradient-kpi-2: linear-gradient(135deg, #D4EAA5 0%, #B4CA7F 100%); // Green variant\n  --unified-gradient-kpi-3: linear-gradient(135deg, #F5D982 0%, #F0D066 100%); // Yellow variant\n  --unified-gradient-kpi-4: linear-gradient(135deg, #F5A5A5 0%, #F08F8F 100%); // Red variant\n  \n  // Transport Mode Gradients (coordinated with palette)\n  --unified-gradient-sea: linear-gradient(135deg, #A5C8EA 0%, #7FA8CA 100%);\n  --unified-gradient-air: linear-gradient(135deg, #C8A5EA 0%, #B87FCA 100%);\n  --unified-gradient-road: linear-gradient(135deg, #F5A5A5 0%, #F08F8F 100%);\n  --unified-gradient-rail: linear-gradient(135deg, #F5D982 0%, #F0D066 100%);\n  --unified-gradient-unknown: linear-gradient(135deg, var(--unified-gray-500) 0%, var(--unified-gray-600) 100%);\n  \n  // Direction Gradients (coordinated)\n  --unified-gradient-import: linear-gradient(135deg, #D4EAA5 0%, #B4CA7F 100%);\n  --unified-gradient-export: linear-gradient(135deg, #A5C8EA 0%, #7FA8CA 100%);\n  --unified-gradient-transit: linear-gradient(135deg, #F5D982 0%, #F0D066 100%);\n  --unified-gradient-other: linear-gradient(135deg, #C8A5EA 0%, #B87FCA 100%);\n}\n\n// Utility Classes for Quick Application\n.unified-bg-primary { background-color: var(--unified-primary-green) !important; }\n.unified-bg-primary-light { background-color: var(--unified-primary-green-light) !important; }\n.unified-bg-primary-dark { background-color: var(--unified-primary-green-dark) !important; }\n\n.unified-bg-secondary { background-color: var(--unified-primary-blue) !important; }\n.unified-bg-secondary-light { background-color: var(--unified-primary-blue-light) !important; }\n.unified-bg-secondary-dark { background-color: var(--unified-primary-blue-dark) !important; }\n\n.unified-bg-success { background-color: var(--unified-success) !important; }\n.unified-bg-info { background-color: var(--unified-info) !important; }\n.unified-bg-warning { background-color: var(--unified-warning) !important; }\n.unified-bg-danger { background-color: var(--unified-danger) !important; }\n\n.unified-text-primary { color: var(--unified-text-primary) !important; }\n.unified-text-secondary { color: var(--unified-text-secondary) !important; }\n.unified-text-success { color: var(--unified-success-dark) !important; }\n.unified-text-info { color: var(--unified-info-dark) !important; }\n.unified-text-warning { color: var(--unified-warning-dark) !important; }\n.unified-text-danger { color: var(--unified-danger-dark) !important; }\n\n.unified-border-light { border-color: var(--unified-border-light) !important; }\n.unified-border-medium { border-color: var(--unified-border-medium) !important; }\n.unified-border-dark { border-color: var(--unified-border-dark) !important; }\n\n// Button Variants with Unified Colors\n.unified-button-primary {\n  --background: var(--unified-primary-green);\n  --background-hover: var(--unified-primary-green-dark);\n  --color: var(--unified-text-on-primary);\n  --border-color: var(--unified-primary-green-dark);\n}\n\n.unified-button-secondary {\n  --background: var(--unified-primary-blue);\n  --background-hover: var(--unified-primary-blue-dark);\n  --color: var(--unified-text-on-primary);\n  --border-color: var(--unified-primary-blue-dark);\n}\n\n.unified-button-success {\n  --background: var(--unified-success);\n  --background-hover: var(--unified-success-dark);\n  --color: var(--unified-text-on-primary);\n  --border-color: var(--unified-success-dark);\n}\n\n.unified-button-outline-primary {\n  --background: transparent;\n  --background-hover: var(--unified-primary-green-light);\n  --color: var(--unified-primary-green-dark);\n  --border-color: var(--unified-primary-green);\n}\n\n// Card Variants with Unified Colors\n.unified-card-primary {\n  background: var(--unified-gradient-green);\n  color: var(--unified-text-on-primary);\n  border: 1px solid var(--unified-primary-green-dark);\n}\n\n.unified-card-secondary {\n  background: var(--unified-gradient-blue);\n  color: var(--unified-text-on-primary);\n  border: 1px solid var(--unified-primary-blue-dark);\n}\n\n// Dark Theme Support - Following application pattern\nbody.dark {\n  // Override primary colors for dark theme\n  --unified-primary-green: #D4EAA5; // Keep main green consistent\n  --unified-primary-green-light: #E2F2C1;\n  --unified-primary-green-dark: #B4CA7F;\n  --unified-primary-green-darker: #A4BA6F;\n  \n  --unified-primary-blue: #90CAF9; // Lighter blue for dark theme\n  --unified-primary-blue-light: #BBDEFB;\n  --unified-primary-blue-dark: #64B5F6;\n  --unified-primary-blue-darker: #42A5F5;\n  \n  // Header backgrounds for dark theme\n  --unified-header-bg: #1A237E;\n  --unified-header-bg-dark: #0D47A1;\n  --unified-content-bg: #121212;\n  --unified-content-bg-dark: #000000;\n  \n  // Neutral colors for dark theme\n  --unified-white: #1E1E1E;\n  --unified-gray-50: #2A2A2A;\n  --unified-gray-100: #333333;\n  --unified-gray-200: #404040;\n  --unified-gray-300: #4D4D4D;\n  --unified-gray-400: #666666;\n  --unified-gray-500: #808080;\n  --unified-gray-600: #999999;\n  --unified-gray-700: #404040;\n  --unified-gray-800: #2A2A2A;\n  --unified-gray-900: #1E1E1E;\n  \n  // Semantic colors adjusted for dark theme\n  --unified-success: #D4EAA5; // Keep main green consistent\n  --unified-success-light: #E2F2C1;\n  --unified-success-dark: #B4CA7F;\n  \n  --unified-info: #90CAF9;\n  --unified-info-light: #BBDEFB;\n  --unified-info-dark: #64B5F6;\n  \n  --unified-warning: #FFD54F;\n  --unified-warning-light: #FFECB3;\n  --unified-warning-dark: #FFC107;\n  \n  --unified-danger: #EF5350;\n  --unified-danger-light: #FFCDD2;\n  --unified-danger-dark: #D32F2F;\n  \n  // Text colors for dark theme\n  --unified-text-primary: #FFFFFF;\n  --unified-text-secondary: #E0E0E0;\n  --unified-text-tertiary: #BDBDBD;\n  --unified-text-disabled: #757575;\n  --unified-text-on-primary: #000000;\n  --unified-text-on-secondary: #000000;\n  \n  // Border colors for dark theme\n  --unified-border-light: rgba(255, 255, 255, 0.12);\n  --unified-border-medium: rgba(255, 255, 255, 0.24);\n  --unified-border-dark: rgba(255, 255, 255, 0.38);\n  \n  // Shadow colors for dark theme\n  --unified-shadow-light: rgba(0, 0, 0, 0.48);\n  --unified-shadow-medium: rgba(0, 0, 0, 0.64);\n  --unified-shadow-dark: rgba(0, 0, 0, 0.80);\n}\n\n.unified-card-light {\n  background: var(--unified-white);\n  color: var(--unified-text-primary);\n  border: 1px solid var(--unified-border-light);\n  box-shadow: 0 2px 4px var(--unified-shadow-light);\n}\n\n// Status Indicators with Unified Colors\n.unified-status-active {\n  background: var(--unified-success);\n  color: var(--unified-text-on-primary);\n}\n\n.unified-status-pending {\n  background: var(--unified-warning);\n  color: var(--unified-text-primary);\n}\n\n.unified-status-inactive {\n  background: var(--unified-gray-400);\n  color: var(--unified-text-on-primary);\n}\n\n.unified-status-error {\n  background: var(--unified-danger);\n  color: var(--unified-text-on-primary);\n}\n\n// Animation and Transition Classes\n.unified-transition {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.unified-hover-lift:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px var(--unified-shadow-medium);\n}\n\n.unified-hover-glow:hover {\n  box-shadow: 0 0 0 3px rgba(212, 234, 165, 0.3); // Green glow\n}\n\n// Responsive Design Helpers\n@media (max-width: 768px) {\n  :root {\n    // Adjust colors for mobile if needed\n    --unified-shadow-light: rgba(0, 0, 0, 0.06);\n    --unified-shadow-medium: rgba(0, 0, 0, 0.10);\n  }\n}\n\n// Print Styles\n@media print {\n  :root {\n    // Ensure good contrast for printing\n    --unified-text-primary: #000000;\n    --unified-text-secondary: #333333;\n    --unified-border-light: #CCCCCC;\n  }\n}\n","// Unified Loading Overlay Component\n@import '../../styles/unified-color-palette.scss';\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  \n  &.overlay-mode {\n    background: rgba(var(--unified-white), 0.9);\n    backdrop-filter: blur(4px);\n    border-radius: inherit;\n  }\n  \n  .loading-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    \n    .spinner-container {\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      \n      .spinner-ring {\n        position: absolute;\n        border-radius: 50%;\n        border: 2px solid transparent;\n        animation: spin 2s linear infinite;\n        \n        &.ring-1 {\n          width: 40px;\n          height: 40px;\n          border-top-color: var(--unified-primary-blue);\n          animation-delay: 0s;\n        }\n        \n        &.ring-2 {\n          width: 32px;\n          height: 32px;\n          border-top-color: var(--unified-primary-green);\n          animation-delay: -0.3s;\n          animation-duration: 1.5s;\n        }\n        \n        &.ring-3 {\n          width: 24px;\n          height: 24px;\n          border-top-color: var(--unified-info);\n          animation-delay: -0.6s;\n          animation-duration: 1s;\n        }\n      }\n    }\n    \n    .loading-text {\n      font-size: 14px;\n      font-weight: 500;\n      color: var(--unified-text-secondary);\n      text-align: center;\n      animation: fadeInUp 0.6s ease-out;\n    }\n  }\n  \n  // Size variations\n  &[data-size=\"small\"] {\n    .loading-content {\n      gap: 12px;\n      \n      .spinner-container .spinner-ring {\n        &.ring-1 { width: 28px; height: 28px; }\n        &.ring-2 { width: 22px; height: 22px; }\n        &.ring-3 { width: 16px; height: 16px; }\n      }\n      \n      .loading-text {\n        font-size: 12px;\n      }\n    }\n  }\n  \n  &[data-size=\"large\"] {\n    .loading-content {\n      gap: 20px;\n      \n      .spinner-container .spinner-ring {\n        &.ring-1 { width: 56px; height: 56px; }\n        &.ring-2 { width: 44px; height: 44px; }\n        &.ring-3 { width: 32px; height: 32px; }\n      }\n      \n      .loading-text {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n// Animations\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
